<template lang="pug">
  div.reports
    div.toolbar
      div.line
        h1.title {{$translate('Отчеты')}}
    div.dashboard
      div(
        v-for="col in rows"
      ).col
        report-card(
        v-for="reportConfig, id in reportConfigData"
        :col="col"
        :reportConfig="reportConfig"
        :key="id"
        )

    router-view
</template>

<script>
  import billingReportConfigData from './utils/billingReportConfigData'
  import reportsMixin from './mixins/reports'
  import ReportCard from "./components/report-card";

  export default {
    components: {ReportCard},
    mixins: [reportsMixin],
    computed: {
      reportConfigData () {
        return billingReportConfigData
      }
    }
  }
</script>
